import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core'
import { TooltipModule } from 'primeng/primeng';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { PermissionModule } from 'app/security/permission';
import { BreadcrumbsModule } from './breadcrumbs';
import { LanguageModule } from 'app/language/language.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    PermissionModule,
    TooltipModule,
    BreadcrumbsModule,
    LanguageModule.forChild()
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    PageNotFoundComponent,
    FooterComponent
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    PageNotFoundComponent,
    FooterComponent
  ]
})
export class UiModule { }



// WEBPACK FOOTER //
// /dist/src/app/ui/ui.module.ts